import styles from './price.scss';
import cn from 'classnames';
import { PriceText } from './cardPrice';

type AppearanceTypes = 'normal' | 'lineThrough' | 'campaign' | 'discount';

export interface Props {
  price: number;
  appearance?: AppearanceTypes;
  className?: string;
  unit?: string;
}

export const Price = ({ price, appearance = 'campaign', className, unit }: Props) => {
  const style = styles[appearance];
  return <PriceText price={price} className={cn(className, style)} unit={unit} />;
};
